import { axios } from "@/utils"

export default {
    getProductFamilies() {
        return axios.get(`/print/api/v1/product-families/`)
    },

    getProducts() {
        // TODO: parametrizzare include_variants_with_price
        return axios.get(`/print/api/v1/products/?include_variants_with_price=true`)
    },

    getProductById(id) {
        return axios.get(`/print/api/v1/products/${id}/`)
    },

    decorateProductConfiguration(body) {
        return axios.post(`/print/api/v1/decorate-product-configuration/`, body)
    },

    getCountries() {
        return axios.get(`/print/api/v1/countries/`)
    }
}
